// extracted by mini-css-extract-plugin
export default {"wrapper":"ContentLoader_wrapper__EDVPk","jobCard":"ContentLoader_jobCard__bZ7VW"};